import React, { useRef } from "react";
import { Sheet, Page, Navbar, NavTitle, Block, Button } from "framework7-react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

interface QRCodeModalProps {
    opened: boolean;
    onClose: () => void;
    qrUrl: string;
    ticketCode?: string;
}

export const QRCodeModal: React.FC<QRCodeModalProps> = ({ opened, onClose, qrUrl, ticketCode }) => {
    const { t } = useTranslation();
    const qrRef = useRef<SVGSVGElement>(null);

    const handleDownload = () => {
        if (!qrRef.current) return;

        const svg = qrRef.current;
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svg);
        const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });

        const url = URL.createObjectURL(svgBlob);
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = svg.clientWidth;
            canvas.height = svg.clientHeight;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.drawImage(img, 0, 0);
                canvas.toBlob((blob) => {
                    if (blob) {
                        const link = document.createElement("a");
                        link.href = URL.createObjectURL(blob);
                        if (ticketCode) {
                            link.download = `ticket_code_${ticketCode}.png`;
                        } else {
                            link.download = `ticketQR.png`;
                        }
                        link.click();
                        URL.revokeObjectURL(link.href);
                    }
                }, "image/png");
            }
            URL.revokeObjectURL(url);
        };
        img.src = url;
    };

    return (
        <Sheet
            opened={opened}
            onSheetClosed={onClose}
            swipeToClose
            backdrop
            className="qr-sheet"
            style={{ height: "50%" }}
        >
            <Page>
                <Navbar>
                    <NavTitle>{t('ticketsPage.ticketURLTitle')}</NavTitle>
                </Navbar>
                <Block className="text-align-center">
                    <QRCodeSVG value={qrUrl} size={200} title={qrUrl} ref={qrRef} />
                    <Button fill onClick={handleDownload} style={{ marginTop: '1rem' }}>
                        {t('ticketsPage.saveAsImage')}
                    </Button>
                </Block>
            </Page>
        </Sheet>
    );
};
